
let API_SERVER = 'https://api.pubtec.com.br'
if(window.location.hostname === 'localhost' || window.location.hostname == 'dev.pubtec') API_SERVER = 'http://localhost:8000'

//estou usando em producao! cuidado! 
//API_SERVER = 'http://127.0.0.1:8000'

export const CONFIGS = Object.freeze({ API_SERVER: API_SERVER })
